export const BEAUTY_GENIUS_TYPE_IN_TAGGING_EVENT = 'beauty-genius-type-in-tagging';
